import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import NavSamplesBar from '../../components/nav/NavSamplesBar';
import {
  updateQueryAggregationLevel,
  updateQueryParams
} from '../../actions/queryParams';
import NavChartOptions from '../../components/nav/NavChartOptions';
import {
  setChartConnectNulls,
  setChartEnergyTypes,
  setChartFetchOnZoom,
  setChartType
} from '../../actions/chartsOptions';
import NavSankeyOptions from '../../components/nav/NavSankeyOptions';
import { setSankeyColumnFilter } from '../../actions/sankeyColumnFilter';
import {
  setSankeyOptionsCosts,
  setSankeyOptionsNames,
  setSankeyOptionsValues
} from '../../actions/sankeyOptions';

export default (WrappedComponent, pageType) => {
  class Wrapper extends Component {
    render() {
      const {
        queryParams,
        updateQueryParams,
        updateQueryAggregationLevel,
        timezone,
        match,
        loading,
        goBack
      } = this.props;
      const isChartTemplate = match.url.includes('charts');
      const isExternalTemplate = match.url.includes('external');
      const isSankeyChildTemplate = match.url.includes('sankey/chart');

      const chartOptions =
        pageType === 'chart' ? (
          <NavChartOptions
            setChartConnectNulls={this.props.setChartConnectNulls}
            setChartFetchOnZoom={this.props.setChartFetchOnZoom}
            setChartType={this.props.setChartType}
            setChartEnergyTypes={this.props.setChartEnergyTypes}
            chartOptions={this.props.chartOptions}
            loading={loading}
          />
        ) : null;

      const sankeyOptions =
        pageType === 'sankey' ? (
          <NavSankeyOptions
            sankeyOptions={this.props.sankeyOptions}
            sankeyColumnFilter={this.props.sankeyColumnFilter}
            setSankeyColumnFilter={this.props.setSankeyColumnFilter}
            setSankeyOptionsCosts={this.props.setSankeyOptionsCosts}
            setSankeyOptionsValues={this.props.setSankeyOptionsValues}
            setSankeyOptionsNames={this.props.setSankeyOptionsNames}
            costs={this.props.costs}
            loading={loading}
          />
        ) : null;

      return (
        <div>
          <NavSamplesBar
            queryParams={queryParams}
            updateQueryParams={updateQueryParams}
            updateQueryAggregationLevel={updateQueryAggregationLevel}
            timezone={timezone}
            isChartTemplate={isChartTemplate}
            pageType={pageType}
            loading={loading}
            NavChartOptions={chartOptions}
            NavSankeyOptions={sankeyOptions}
            isExternalTemplate={isExternalTemplate}
            isSankeyChildTemplate={isSankeyChildTemplate}
            goBack={goBack}
          />

          <WrappedComponent {...this.props} />
        </div>
      );
    }
  }

  return connect(mapStateToProps, {
    updateQueryParams,
    updateQueryAggregationLevel,
    setChartConnectNulls,
    setChartFetchOnZoom,
    setChartEnergyTypes,
    setChartType,
    setSankeyColumnFilter,
    setSankeyOptionsCosts,
    setSankeyOptionsValues,
    setSankeyOptionsNames
  })(Wrapper);
};

const mapStateToProps = (state, ownProps) => ({
  queryParams: state.queryParams,
  timezone: state.app.timezone,
  chartOptions: state.chartOptions,
  sankeyOptions: state.sankeyOptions,
  costs: state.site && state.site.cost ? state.site.cost : null,
  sankeyColumnFilter: state.sankeyColumnFilter,
  loading: state.loading.samples,
  goBack: ownProps.history.goBack
});



// WEBPACK FOOTER //
// ./src/container/wrapper/WithTimeSeriesControls.js